import { time } from './zod'

export const timeWithoutSeconds = (timeString: string) =>
  time().parse(timeString.slice(0, 5)) // Extracts "HH:mm" from "HH:mm:ss"
